import stripsWithShop1700 from 'shared/assets/img/plotBackgrounds/stripsWithShop-1700.png';
import stripsWithShop1200 from 'shared/assets/img/plotBackgrounds/stripsWithShop-1200.png';
import stripsWithShop1024 from 'shared/assets/img/plotBackgrounds/stripsWithShop-1024.png';
import stripsWithShop768 from 'shared/assets/img/plotBackgrounds/stripsWithShop-768.png';
import stripsWithShop370 from 'shared/assets/img/plotBackgrounds/stripsWithShop-370.png';
import stripsWithShopTn from 'shared/assets/img/plotBackgrounds/stripsWithShop-tn.png';
import startPage1700 from 'shared/assets/img/startPage/startPage-1700.png';
import startPage1200 from 'shared/assets/img/startPage/startPage-1200.png';
import startPage1024 from 'shared/assets/img/startPage/startPage-1024.png';
import startPage768 from 'shared/assets/img/startPage/startPage-768.png';
import startPage370 from 'shared/assets/img/startPage/startPage-370.png';
import startPageTn from 'shared/assets/img/startPage/startPage-tn.png';
import room1700 from 'shared/assets/img/plotBackgrounds/room-1700.png';
import room1200 from 'shared/assets/img/plotBackgrounds/room-1200.png';
import room1024 from 'shared/assets/img/plotBackgrounds/room-1024.png';
import room768 from 'shared/assets/img/plotBackgrounds/room-768.png';
import room370 from 'shared/assets/img/plotBackgrounds/room-370.png';
import roomTn from 'shared/assets/img/plotBackgrounds/room-tn.png';
import townAuth1700 from 'shared/assets/img/auth/town-1700.png';
import townAuth1200 from 'shared/assets/img/auth/town-1200.png';
import townAuth1024 from 'shared/assets/img/auth/town-1024.png';
import townAuth768 from 'shared/assets/img/auth/town-768.png';
import townAuthTn from 'shared/assets/img/auth/town-tn.png';
import fallingGlitter1700 from 'shared/assets/img/plotBackgrounds/fallingGlitter-1700.png';
import fallingGlitter1200 from 'shared/assets/img/plotBackgrounds/fallingGlitter-1200.png';
import fallingGlitter1024 from 'shared/assets/img/plotBackgrounds/fallingGlitter-1024.png';
import fallingGlitter768 from 'shared/assets/img/plotBackgrounds/fallingGlitter-768.png';
import fallingGlitter370 from 'shared/assets/img/plotBackgrounds/fallingGlitter-480.png';
import school1700 from 'shared/assets/img/plotBackgrounds/school-1700.png';
import roomStudent1700 from 'shared/assets/img/plotBackgrounds/room2-1700.png';
import roomStudentTn from 'shared/assets/img/plotBackgrounds/room2-tn.png';
import monthPassed1700 from 'shared/assets/img/plotBackgrounds/monthPassed-1700.png';
import monthPassed1200 from 'shared/assets/img/plotBackgrounds/monthPassed-1200.png';
import monthPassed1024 from 'shared/assets/img/plotBackgrounds/monthPassed-1024.png';
import monthPassed768 from 'shared/assets/img/plotBackgrounds/monthPassed-768.png';
import monthPassed370 from 'shared/assets/img/plotBackgrounds/monthPassed-480.png';
import monthPassedTn from 'shared/assets/img/plotBackgrounds/monthPassed-tn.png';
import hospitalWard1700 from 'shared/assets/img/plotBackgrounds/hospitalWard-1700.png';
import hospitalWardTn from 'shared/assets/img/plotBackgrounds/hospitalWard-tn.png';
import office1700 from 'shared/assets/img/plotBackgrounds/office-sbsj-1700.png';
import officeTn from 'shared/assets/img/plotBackgrounds/office-sbsj-tn.png';
import accident1700 from 'shared/assets/img/plotBackgrounds/accident-1700.png';
import accidentTn from 'shared/assets/img/plotBackgrounds/accident-tn.png';
import disease1700 from 'shared/assets/img/plotBackgrounds/disease-1700.png';
import diseaseTn from 'shared/assets/img/plotBackgrounds/disease-tn.png';
import flood1700 from 'shared/assets/img/plotBackgrounds/flood-1700.png';
import floodTn from 'shared/assets/img/plotBackgrounds/flood-tn.png';
import apartment1700 from 'shared/assets/img/plotBackgrounds/apartment-1700.png';
import apartmentTn from 'shared/assets/img/plotBackgrounds/apartment-tn.png';
import shooterGame1700 from 'shared/assets/img/plotBackgrounds/shooterGame-1700.png';
import shooterGameTn from 'shared/assets/img/plotBackgrounds/shooterGame-tn.png';
import myShop1700 from 'shared/assets/img/plotBackgrounds/myShop-1700.png';
import myShop1200 from 'shared/assets/img/plotBackgrounds/myShop-1200.png';
import myShop1024 from 'shared/assets/img/plotBackgrounds/myShop-1024.png';
import myShop768 from 'shared/assets/img/plotBackgrounds/myShop-768.png';
import myShop370 from 'shared/assets/img/plotBackgrounds/myShop-370.png';
import myShopTn from 'shared/assets/img/plotBackgrounds/myShop-tn.png';
import myFinance1700 from 'shared/assets/img/plotBackgrounds/myFinance-1700.png';
import myFinance1200 from 'shared/assets/img/plotBackgrounds/myFinance-1200.png';
import myFinance1024 from 'shared/assets/img/plotBackgrounds/myFinance-1024.png';
import myFinance768 from 'shared/assets/img/plotBackgrounds/myFinance-768.png';
import myFinance370 from 'shared/assets/img/plotBackgrounds/myFinance-370.png';
import myFinanceTn from 'shared/assets/img/plotBackgrounds/myFinance-tn.png';
import LoadingLevel1_1700 from 'shared/assets/img/levelLoading/LoadingLevel1_1700.png';
import LoadingLevel1_1200 from 'shared/assets/img/levelLoading/LoadingLevel1_1200.png';
import LoadingLevel1_1024 from 'shared/assets/img/levelLoading/LoadingLevel1_1024.png';
import LoadingLevel1_768 from 'shared/assets/img/levelLoading/LoadingLevel1_768.png';
import LoadingLevel1_370 from 'shared/assets/img/levelLoading/LoadingLevel1_370.png';
import LoadingLevel2_1700 from 'shared/assets/img/levelLoading/LoadingLevel2_1700.png';
import LoadingLevel2_1200 from 'shared/assets/img/levelLoading/LoadingLevel2_1200.png';
import LoadingLevel2_1024 from 'shared/assets/img/levelLoading/LoadingLevel2_1024.png';
import LoadingLevel2_768 from 'shared/assets/img/levelLoading/LoadingLevel2_768.png';
import LoadingLevel2_370 from 'shared/assets/img/levelLoading/LoadingLevel2_370.png';
import LoadingLevel3_1700 from 'shared/assets/img/levelLoading/LoadingLevel3_1700.png';
import LoadingLevel3_1200 from 'shared/assets/img/levelLoading/LoadingLevel3_1200.png';
import LoadingLevel3_1024 from 'shared/assets/img/levelLoading/LoadingLevel3_1024.png';
import LoadingLevel3_768 from 'shared/assets/img/levelLoading/LoadingLevel3_768.png';
import LoadingLevel3_370 from 'shared/assets/img/levelLoading/LoadingLevel3_370.png';
import LoadingLevel4_1700 from 'shared/assets/img/levelLoading/LoadingLevel4_1700.png';
import LoadingLevel4_1200 from 'shared/assets/img/levelLoading/LoadingLevel4_1200.png';
import LoadingLevel4_1024 from 'shared/assets/img/levelLoading/LoadingLevel4_1024.png';
import LoadingLevel4_768 from 'shared/assets/img/levelLoading/LoadingLevel4_768.png';
import LoadingLevel4_370 from 'shared/assets/img/levelLoading/LoadingLevel4_370.png';

export const backgroundsData: any = {
    startPage: {
        1700: startPage1700,
        1200: startPage1200,
        1024: startPage1024,
        768: startPage768,
        370: startPage370,
        tn: startPageTn,
    },
    room: {
        1700: room1700,
        1200: room1200,
        1024: room1024,
        768: room768,
        370: room370,
        tn: roomTn,
    },
    roomStudent: {
        1700: roomStudent1700,
        1200: roomStudent1700,
        1024: roomStudent1700,
        768: roomStudent1700,
        370: roomStudent1700,
        tn: roomStudentTn,
    },
    stripsWithShop: {
        1700: stripsWithShop1700,
        1200: stripsWithShop1200,
        1024: stripsWithShop1024,
        768: stripsWithShop768,
        370: stripsWithShop370,
        tn: stripsWithShopTn,
    },
    townAuth: {
        1700: townAuth1700,
        1200: townAuth1200,
        1024: townAuth1024,
        768: townAuth768,
        370: townAuth768,
        tn: townAuthTn,
    },
    strips: {
        1700: stripsWithShop1700,
        1200: stripsWithShop1200,
        1024: stripsWithShop1024,
        768: stripsWithShop768,
        370: stripsWithShop370,
        tn: stripsWithShopTn,
    },
    glitters: {
        1700: fallingGlitter1700,
        1200: fallingGlitter1200,
        1024: fallingGlitter1024,
        768: fallingGlitter768,
        370: fallingGlitter370,
        tn: stripsWithShopTn,
    },
    school: {
        1700: school1700,
        1200: school1700,
        1024: school1700,
        768: school1700,
        370: school1700,
        tn: stripsWithShopTn,
    },
    hospitalWard: {
        1700: hospitalWard1700,
        1200: hospitalWard1700,
        1024: hospitalWard1700,
        768: hospitalWard1700,
        370: hospitalWard1700,
        tn: hospitalWardTn,
    },
    monthPassed: {
        1700: monthPassed1700,
        1200: monthPassed1200,
        1024: monthPassed1024,
        768: monthPassed768,
        370: monthPassed370,
        tn: monthPassedTn,
    },
    myShop: {
        1700: myShop1700,
        1200: myShop1200,
        1024: myShop1024,
        768: myShop768,
        370: myShop370,
        tn: myShopTn,
    },
    myFinance: {
        1700: myFinance1700,
        1200: myFinance1200,
        1024: myFinance1024,
        768: myFinance768,
        370: myFinance370,
        tn: myFinanceTn,
    },
    office: {
        1700: office1700,
        1200: office1700,
        1024: office1700,
        768: office1700,
        370: office1700,
        tn: officeTn,
    },
    accident: {
        1700: accident1700,
        1200: accident1700,
        1024: accident1700,
        768: accident1700,
        370: accident1700,
        tn: accidentTn,
    },
    disease: {
        1700: disease1700,
        1200: disease1700,
        1024: disease1700,
        768: disease1700,
        370: disease1700,
        tn: diseaseTn,
    },
    flood: {
        1700: flood1700,
        1200: flood1700,
        1024: flood1700,
        768: flood1700,
        370: flood1700,
        tn: floodTn,
    },
    apartment: {
        1700: apartment1700,
        1200: apartment1700,
        1024: apartment1700,
        768: apartment1700,
        370: apartment1700,
        tn: apartmentTn,
    },
    shooterGame: {
        1700: shooterGame1700,
        1200: shooterGame1700,
        1024: shooterGame1700,
        768: shooterGame1700,
        370: shooterGame1700,
        tn: shooterGameTn,
    },
    level1: {
        1700: LoadingLevel1_1700,
        1200: LoadingLevel1_1200,
        1024: LoadingLevel1_1024,
        768: LoadingLevel1_768,
        370: LoadingLevel1_370,
        tn: "",
    },
    level2: {
        1700: LoadingLevel2_1700,
        1200: LoadingLevel2_1200,
        1024: LoadingLevel2_1024,
        768: LoadingLevel2_768,
        370: LoadingLevel2_370,
        tn: "",
    },
    level3: {
        1700: LoadingLevel3_1700,
        1200: LoadingLevel3_1200,
        1024: LoadingLevel3_1024,
        768: LoadingLevel3_768,
        370: LoadingLevel3_370,
        tn: "",
    },
    level4: {
        1700: LoadingLevel4_1700,
        1200: LoadingLevel4_1200,
        1024: LoadingLevel4_1024,
        768: LoadingLevel4_768,
        370: LoadingLevel4_370,
        tn: "",
    },
};
